"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CataloguesLandingPage = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _useTranslations = require("../../hooks/useTranslations");
var _LatestCatalogues = require("../LatestCatalogues");
var _OtherCatalogues = require("../OtherCatalogues");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const CataloguesLandingPage = ()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    const { translations } = (0, _useTranslations.useTranslations)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        "data-testid": getTestId(_constants.CATALOGUES_LANDING_PAGE),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_LatestCatalogues.LatestCatalogues, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                variant: "h4",
                component: "h2",
                children: translations.landingPageOtherCataloguesTitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_OtherCatalogues.OtherCatalogues, {})
        ]
    });
};
exports.CataloguesLandingPage = CataloguesLandingPage;
